<template>
    <order-list order-type="Reactive"></order-list>
</template>
<script>
    const list = () => import("./list")
    export default {
        name: 'joblist-all',
        components: {
            'order-list' : list
        },
        data() { return {} },
        computed: {},
        created() {},
        watch: {},
        methods: {}
    }
</script>
